import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import AllUsers from "../pages/allUsers";
import Settings from "../pages/settings";
import Reports from "../pages/reports";
import NotFound from "../notfound";
import NotAllowed from "../notallowed";
import Blue from "../pages/blue";
import Purple from "../pages/purple";
import Red from "../pages/red";
import Pink from "../pages/pink";
// import header from ""
import { connect } from "react-redux";

class Routes extends Component {

  render() {

    const { xdr, oxdr, xdrp ,compliance } = (this.props.posts && this.props.posts[0])?this.props.posts[0]:{xdr:false,oxdr:false,xdrp:false,compliance:false};

    return (
      <BrowserRouter>
        <Switch>
          {/* homepage based on roles (blue, red, purple, pink) */}
          {(() => {
            if (xdr === true) {
              return <Route path="/" exact component={Blue} />;
            } else if (xdrp === true) {
              return <Route path="/" exact component={Purple} />;
            } else if (oxdr === true) {
              return <Route path="/" exact component={Red} />;
            } else if (compliance === true) {
              return <Route path="/" exact component={Pink} />;
            }
          })()}

          {/* routes based on roles */}
          {this.props.posts.map((post) => post.xdr)[0] === true && (
            <Route path="/xdr" exact component={Blue} />
          )}
          {this.props.posts.map((post) => post.xdrp)[0] === true && (
            <Route path="/xdrp" exact component={Purple} />
          )}
          {this.props.posts.map((post) => post.oxdr)[0] === true && (
            <Route path="/oxdr" exact component={Red} />
          )}
          {this.props.posts.map((post) => post.compliance)[0] === true && (
            <Route path="/compliance" exact component={Pink} />
          )}

          {/* error routes */}
          <Route path="/404" exact component={NotFound} />
          <Route path="/403" exact component={NotAllowed} />

          {/* admin routes */}
          <Route path="/users" exact component={AllUsers} />
          <Route path="/settings" exact component={Settings} />
          <Route path="/reports" exact component={Reports} />

          {/* error for other pages */}
          <Route path="/*" exact component={NotFound} />
        </Switch>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state) => {
  return { posts: state.posts };
};

export default connect(mapStateToProps)(Routes);
